import { memberGQLFields } from '../network/index.js';
import { postGQLFields } from '../post/index.js';
const BASIC_MODERATION_ITEM_ENTITY_FIELDS = {
    onMember: 'basic',
    onPost: 'basic',
};
const ALL_MODERATION_ITEM_ENTITY_FIELDS = {
    onMember: 'all',
    onPost: 'all',
};
export const moderationItemEntityGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_MODERATION_ITEM_ENTITY_FIELDS;
    if (fields === 'all')
        fields = ALL_MODERATION_ITEM_ENTITY_FIELDS;
    return `
    __typename
    ${fields.onMember
        ? `
      ... on Member {
        ${memberGQLFields(fields.onMember)}
      }
    `
        : ``}
    ${fields.onPost
        ? `
      ... on Post {
        ${postGQLFields(fields.onPost)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=moderationItemEntity.fields.js.map